import React from 'react';
import PropTypes from 'prop-types';

// Styled.
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';
import * as S from './styled';

const ToggleLanguage = ({ value, action, disabled = false }) => (
  <S.Languages>
    <S.Languages>
      <S.Button key="nl" isActive={value === 'nl'} disabled={disabled} onClick={() => action('nl')}>
        <div>
          <img src="/public/flags/nl.svg" alt="Nederlandse vlag" /> Nederlands
        </div>
        {value === 'nl' && <FontAwesomeIcon icon={byPrefixAndName.fal.check} />}
      </S.Button>
      <S.Divider />
      <S.Button key="en" isActive={value === 'en'} disabled={disabled} onClick={() => action('en')}>
        <div>
          <img src="/public/flags/en.svg" alt="English flag" /> English
        </div>
        {value === 'en' && <FontAwesomeIcon icon={byPrefixAndName.fal.check} />}
      </S.Button>
    </S.Languages>
  </S.Languages>
);

ToggleLanguage.propTypes = {
  value: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ToggleLanguage;
